module.exports = __webpack_public_path__ + "media/svg/langue-gris-a9d33e32.svg";